import React from 'react'

import NationalResult from '../../../models/NationalResult'
import Party from '../../../models/Party'
import Utilities from '../../../utils/Utilities'

interface IProps {
  nationalResult: NationalResult
}

class NationalResultTable extends React.Component<IProps> {
  public render(): JSX.Element {
    const { nationalResult } = this.props

    const partyHeaders = Party.allPartiesArray().map(
      (party): JSX.Element => <th key={party.key}>{party.key}</th>
    )

    const seatCells = Party.allPartiesArray().map(
      (party): JSX.Element => {
        const result = nationalResult.partyResultByParty(party)
        return (
          <td key={party.key} style={{ color: party.rgbColor }}>
            <h2>{result ? result.seatCount : '—'}</h2>
          </td>
        )
      }
    )

    const seatPercentCells = Party.allPartiesArray().map(
      (party): JSX.Element => {
        const result = nationalResult.partyResultByParty(party)
        return (
          <td key={party.key} style={{ color: party.rgbColor }}>
            {result ? Utilities.formatPercent(result.seatPercent, 0) : '—'}
          </td>
        )
      }
    )

    const voteCells = Party.allPartiesArray().map(
      (party): JSX.Element => {
        const result = nationalResult.partyResultByParty(party)
        return (
          <td key={party.key} style={{ color: party.rgbColor }}>
            {result ? Utilities.formatPercent(result.votePercent) : '—'}
          </td>
        )
      }
    )

    return (
      <div>
        <h2>National results</h2>
        <table className="table text-right">
          <thead>
            <tr>
              <th></th>
              {partyHeaders}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Seats
                <br />
                <small>{nationalResult.totalSeatCount} total</small>
              </td>
              {seatCells}
            </tr>
            <tr>
              <td>Seat %</td>
              {seatPercentCells}
            </tr>
            <tr>
              <td>Vote %</td>
              {voteCells}
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default NationalResultTable
